export default __webpack_public_path__ + "static/0315-782cae5e5b7d14c3d54c3951575de564.jpeg";